import React from 'react';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import './App.css';

const App = () => (
  <>
    <Navbar />
    <Home />
    <About />
    <Projects />
    <Footer />
  </>
);

export default App;
